export function bankersRound(value: number, decimals: number = 0): number {
    const factor = Math.pow(10, decimals);

    // Shift the decimal point <<decimals>> places to the right
    const scaledNum = value * factor;
    const integerPart = Math.floor(scaledNum);
    const fractionalPart = scaledNum - integerPart;
    const epsilon = 1e-10; //Small threshold for handling fp precision

    // Fractional tolerance check for 0.5
    if(Math.abs(fractionalPart - 0.5) < epsilon) {
        // If we're exactly halfway, round to the nearest even integer
        if (integerPart % 2 === 0) {
            // Up if up is even
            return integerPart / factor;
        } else {
            // Else down
            return (integerPart + 1) / factor;
        }
    } else {
        // All other cases are regular rounding
        return Math.round(scaledNum) / factor;
    }
}

interface SourceAssessmentRegions {
    source_name: string;
    regions: { start: string; end: string; formula: string }[];
}

interface AssessmentRegion {
    start: string;
    end: string;
    formulas: string[];
}

export function buildAssessmentRegions(sourceRegions: SourceAssessmentRegions[]): AssessmentRegion[] {
    const regionMap = new Map<string, AssessmentRegion>();
    for (const source of sourceRegions) {
        for (const { start, end, formula } of source.regions) {
            const key = `${start}_${end}`;
            if (!regionMap.has(key)) {
                regionMap.set(key, { start, end, formulas: [] });
            }
            regionMap.get(key)!.formulas.push(formula);
        }
    }
    return Array.from(regionMap.values());
}
